jQuery(document).ready(function($) {
    'use strict';

    $(document).on('click', '.copy-button', function() {

        const $alert = $('<div class="copied">Kopierad</div>');

        let copy_id = $(this).data('id');
        let copy_val = $('.copy-element[data-id*=' + copy_id + ']').data('text');

        $('<textarea/>').appendTo('body').val(copy_val).select().each(function() {
            document.execCommand('copy');
        }).remove();

        $(this).append($alert);
        $alert.fadeIn(200);

        setTimeout(function() {
            $alert.fadeOut(200, function() {
                $alert.remove();
            });
        }, 1000);

    });

});
